// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"app-content__blockCommon___4NHJH","content":"app-content__content___1eZ65","page":"app-content__page___1kopS"};